export const getProjectAccessMembers = (workspaceId, workspaces) => {
    const workspace = workspaces.find((item) => item.id === workspaceId);
    return workspace?.members || [];
};
